import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import "./jobdetail.css";
import SEOHead from '../components/SEOHead';
import Footer from '../components/Footer';

const jobData = {
     "digital-marketing-intern": {
    title: "Graduate Internship",
    location: "Coimbatore ( On - site )",
    posted: "24 Sept 2026",
    type: "Intern",
    level: "0 to 6 months",
    description: `We are seeking a motivated and creative Digital Marketing Intern to support our marketing and business development activities. The intern will assist in developing digital campaigns, creating engaging content, managing social media platforms, improving online visibility, and analysing marketing performance.
                
                Key Responsibilities:

                Content Creation & Marketing

                    • Create social media posts, banners, reels, videos, and marketing collateral.
                    • Develop website, blog, and newsletter content.
                    • Assist in creating case studies, product brochures, and success stories.

                Social Media Management

                    • Manage LinkedIn, Facebook, Instagram, X, and YouTube channels.
                    • Schedule and publish content regularly.
                    • Monitor engagement and respond to audience interactions.

                SEO & Website Optimisation

                    • Support on-page and off-page SEO activities.
                    • Conduct keyword research and competitor analysis.
                    • Monitor website performance using analytics tools.

                Digital Campaigns

                    • Assist in planning and executing Google Ads and social media advertising campaigns.
                    • Track campaign performance and prepare reports.
                    • Support lead-generation activities.

                Analytics & Reporting

                    • Use tools such as Google Analytics and Search Console.
                    • Analyse traffic, engagement, and conversion metrics.
                    • Generate weekly and monthly performance reports.

                Market Research

                    • Research industry trends, competitor activities, and emerging technologies.
                    • Identify opportunities to improve brand visibility and customer engagement.
                    
                Skills & Qualifications

                    • Pursuing or recently completed a degree in Marketing, Business Administration, Communication, Digital Marketing, Media Studies, or related fields.
                    • Strong written and verbal communication skills.
                    • Familiarity with social media platforms and digital marketing concepts.
                    • Basic knowledge of SEO, Google Analytics, and digital advertising.
                    • Experience with Canva, Adobe Creative Suite, or similar design tools is desirable.
                    • Creative mindset with strong attention to detail.
                    • Ability to work independently and collaboratively.

                Preferred Skills

                    • Content writing and copywriting.
                    • Video editing and graphic design.
                    • Social media analytics.
                    • Email marketing tools.
                    • Basic knowledge of WordPress or website management.

                ( With potential conversion to a full-time role based on performance )
                  `
    },

    "business-development-associate": {
    title: "Business Development Associate",
    location: "Coimbatore ( On - site )",
    posted: "24 Sept 2026",
    type: "Full-time",
    level: "0 to 6 months",
    description: `We are seeking enthusiastic and driven Business Development Associate to support our growth initiatives. The Associate will work closely with the leadership team to identify new business opportunities, build strategic partnerships, support proposal development, and contribute to sales and market expansion activities.
                  
                Key Responsibilities:

                Market Research & Opportunity Identification

                    • Conduct market research to identify emerging industry trends and opportunities.
                    • Analyse competitors, customers, and target markets.
                    • Maintain databases of potential clients, industry contacts, and prospects.

                Lead Generation & Client Engagement

                    • Identify and engage potential clients through various channels.
                    • Support outreach campaigns via email, LinkedIn, and phone.
                    • Schedule meetings and assist in client relationship management.

                Proposal & Bid Support

                    • Assist in preparing business proposals, presentations, and capability statements.
                    • Support government tenders, grant applications, and partnership proposals.
                    • Contribute to project documentation and business reports.

                Partnership Development

                    • Identify collaboration opportunities with universities, industries, innovation centres, and government agencies.
                    • Support MoU development and stakeholder engagement activities.
                    • Assist in maintaining relationships with strategic partners.

                Sales Support

                    • Track sales opportunities and maintain CRM records.
                    • Support business development meetings and follow-up activities.
                    • Prepare sales performance summaries and pipeline reports.

                Strategic Initiatives

                    • Support the launch of new products, Centres of Excellence, and innovation programmes.
                    • Assist in evaluating new market entry opportunities.
                    • Participate in customer discovery and business validation exercises.
                    
                Skills & Qualifications

                    • Pursuing or recently completed a degree in Business Administration, Management, Marketing, Engineering, Economics, or related disciplines.
                    • Strong communication, presentation, and interpersonal skills.
                    • Excellent research and analytical capabilities.
                    • Ability to prepare professional reports and presentations.
                    • Strong organisational and time-management skills.
                    • Proficiency in Microsoft Office (Word, Excel, PowerPoint).
                    • Self-motivated with an entrepreneurial mindset.

                Preferred Skills

                    • Familiarity with B2B sales and business development.
                    • Experience with LinkedIn networking and outreach.
                    • Knowledge of proposal writing or grant funding.
                    • Interest in technology, innovation, smart cities, sustainability, or research commercialisation.
                    • CRM and market intelligence tools experience.


                  `
    },
    
    "student-intern": {
    title: "Digital Intern",
    location: "Coimbatore ( On - site )",
    posted: "10 June 2026",
    type: "Intern",
    level: "0 to 6 months",
    description: `We are looking for a curious and motivated Digital Intern to support the end-to-end design, development, and implementation of real-world projects across various domains. 
                  This structured 3 - 6 month internship (with potential conversion to a full-time role based on performance) will provide hands-on exposure to innovation, collaboration, problem-solving, and project execution.

                  Key Responsibilities:

                  • Contribute to idea generation, research, data collection, and solution design for ongoing projects.
                  • Support development activities such as documentation, basic coding, data analysis, modeling, or prototyping.
                  • Participate in testing, quality checks, or user feedback sessions to improve project outcomes.
                  • Maintain clear and organized documentation - reports, data logs, design notes, and progress summaries.
                  • Collaborate with cross-functional teams (engineering, design, operations and communication) to deliver project milestones.
                  • Assist in preparing project presentations, dashboards, and reports for review meetings.
                  • Communicate effectively with internal and external stakeholders to coordinate deliverables.
                  • Support administrative and coordination tasks such as tracking progress, updating repositories, and handling version control.
                  • Learn the fundamentals of professional workflows, project planning, and teamwork in a multidisciplinary setting.
                  • Participate in internal reviews - share learnings, present updates, and receive constructive feedback.


                  Qualifications:

                  • Currently pursuing a Bachelor's or Master's degree in Engineering, Computer Science, Management, Data Science, or any related field.
                  • Basic understanding of programming, documentation, research, or data analysis (depending on background).
                  • Familiarity with tools like MS Office/Google Workspace, documentation tools, or version control (Git) is an added advantage.
                  • Ability to learn quickly and adapt to new technologies, tools, and project requirements.

                  What You'll Learn:

                  • Practical experience in real-world project lifecycles - from concept to execution.
                  • Problem-solving through research, analysis, and collaboration.
                  • Documentation, version control, and workflow management best practices.
                  • Professional communication, teamwork, and presentation skills.
                  • Industry insights into how cross-departmental collaboration drives innovation.

                  `
    },
    "electronics-engineer": {
        title: "Electronic Design Engineer",
        location: "Coimbatore ( On - site )",
        posted: "01 July 2026",
        type: "Full-time",
        level: "2+ years",
        description: `This role involves the end-to-end development of electronic systems, with a particular focus on designing high-performance sensors and circuits for medical applications. You will contribute to the creation of innovative, reliable, and manufacturable hardware solutions, collaborating closely with cross-functional teams including firmware, mechanical, and product development engineers.                    
                    
                    Key Responsibilities:
                            
                            • Design and develop analog and digital electronic circuits and systems.
                            • Create schematics and PCB layouts using industry-standard tools (e.g., Altium, Eagle, KiCAD).
                            • Perform simulations, prototyping, and testing of electronic hardware.
                            • Collaborate with firmware, mechanical, and manufacturing teams to ensure seamless integration.
                            • Conduct design reviews and ensure compliance with relevant standards and regulations.
                            • Troubleshoot and resolve design and production issues.
                                                
                    Qualifications:

                            • Bachelor's or Master's degree in Electronics Engineering, Electrical Engineering, or a related field.
                            • 2+ years of experience in hardware design, preferably in medical or safety-critical systems.
                            • Strong knowledge of circuit simulation, PCB design, and testing tools.
                            • Familiarity with EMC/EMI considerations and design for manufacturability.
                            • Proficiency in using lab equipment such as oscilloscopes, logic analyzers, and multimeters.
                            • Familiarity with medical device standards and risk management practices.
                    
                    Soft Skills: 

                            • Microcontroller/ FPGA (VHDL/Verilog) based system development.
                            • Familiarity with regulatory standards 
                            • Understanding of sensor integration and interfacing with various sensor types (e.g., temperature, pressure, motion, optical).
                            • Understanding of system integration and the ability to work across hardware, firmware, and software domains.
                    `,
    },
    "project-admin": {
        title: "Project Administrator",
        location: "Coimbatore ( On - site )",
        posted: "01 May 2026",
        type: "Full-time",
        level: "0 - 1 year",
        description: `We are looking for a detail-oriented and organised Project Administrator to support our project teams with planning, coordination, and documentation. The ideal candidate will ensure smooth workflow, maintain accurate records, and assist in tracking project progress to meet deadlines and deliverables effectively.

                Responsibilities:

                    • Assist project managers with project planning, scheduling, and maintaining timelines.
                    • Prepare, organise, and maintain project documentation, reports, and meeting minutes.
                    • Coordinate communication between teams, clients, and stakeholders to ensure clarity.
                    • Monitor project progress, update trackers, and follow up on pending tasks or deliverables.
                    • Manage project-related files, contracts, invoices, and procurement documentation. 
                    • Arrange project meetings, prepare agendas, and ensure follow-up actions are completed.
                    

                Qualifications:

                    • Bachelor's degree in Business Administration, Project Management, or a related field.
                    • 0 - 1 years of experience in project coordination or administrative support roles.
                    • Proficiency in MS Office (Excel, Word, PowerPoint) and project management tools (Asana, Trello, or similar).
                    • Ability to manage multiple tasks simultaneously and meet deadlines.
                    • Familiarity with basic project management methodologies (Agile, Waterfall) is an added advantage.
                
                Soft Skills:

                    • Excellent communication and interpersonal skills.
                    • Strong organisational and time-management abilities.
                    • Attention to detail with a high level of accuracy in documentation.
                    • Problem-solving mindset with the ability to anticipate and resolve issues.
                    • Ability to work collaboratively with cross-functional teams.
                    • Proactive, reliable, and adaptable in a fast-paced environment.
                 `
    },
    "innovation-engineering-graduate-pathway":{
        title: "Innovation & Engineering Graduate Pathway",
        location: "Coimbatore ( On - site )",
        posted: "01 July 2026",
        type: "Full-time / Part-time",
        level: "0 to 6 months",
        description:`Our Innovation & Engineering Graduate Pathway is designed to accelerate your career by combining advanced technical training with real-world consulting experience. Over 12–18 months, you will gain exposure to cutting-edge technologies, strategic problem-solving, and client engagement, preparing you for a successful career in technical consulting.

            What You'll Do:

                • Participate in structured technical training modules.
                • Work on live projects across multiple domains through rotational assignments.
                • Collaborate with experienced mentors and industry experts.
                • Deliver a capstone project addressing real client challenges.
                • Develop technical, analytical, and leadership skills for future roles.
          
            What We're Looking For:

                • Recent graduates (UG/PG) in Engineering, ((UG/PG) in Science, or related fields.
                • Strong analytical and problem-solving skills.
                • Passion for technology and innovation.
                • Excellent communication and interpersonal skills.
                • Ability to work collaboratively in a fast-paced environment.
 
            Why Join Us?

                • Comprehensive training and certifications.
                • Hands-on experience with real projects.
                • Mentorship from seasoned professionals.
                • Clear career progression opportunities.
                • Exposure to emerging technologies and consulting practices.
`
    },
     "electronics-intern": {
    title: "Electronics Intern",
    location: "Coimbatore ( On - site )",
    posted: "09 July 2026",
    type: "Intern",
    level: "0 - 6 months",
    description: `We are looking for a motivated Electronics Intern who is passionate about electronics, circuit design, embedded systems, and hardware development. The intern will work closely with the engineering team to support the design, testing, troubleshooting, and documentation of electronic systems and devices.

                  Key Responsibilities:

                • Assist in the design and development of electronic circuits and hardware components.
                • Support PCB design, assembly, and testing activities.
                • Perform circuit simulation and analysis using relevant software tools.
                • Assist in microcontroller and embedded system programming.
                • Conduct hardware debugging and troubleshooting.
                • Participate in prototype development and product testing.
                • Prepare technical documentation, test reports, and project records.
                • Support research and evaluation of electronic components and technologies.
                • Follow engineering standards and safety procedures during development activities.


                Required Skills:

                • Basic knowledge of Analog and Digital Electronics.
                • Understanding of Electronic Components and Circuit Design.
                • Familiarity with Microcontrollers (Arduino, ESP32, STM32, etc.).
                • Knowledge of Embedded C/C++ is preferred.
                • Basic understanding of PCB Design Tools (KiCad, Eagle, Altium, etc.).
                • Strong problem-solving and analytical skills.
                • Good communication and documentation abilities.

                Eligibility:

                • Pursuing or recently completed Diploma/B.E./B.Tech in Electronics & Communication Engineering (ECE), Electronics & Instrumentation (E&I), Electrical & Electronics Engineering (EEE), or related disciplines.
                • Strong interest in electronics hardware and embedded systems.
                • Willingness to learn and work on real-world projects.

                What You'll Gain:

                • Hands-on experience in electronics product development.
                • Exposure to embedded systems and hardware testing.
                • Mentorship from experienced engineers.
                • Opportunity to work on live projects and prototypes.
                • Internship completion certificate and performance-based recommendation.


                  `
    },
    "ai-intern": {
    title: "AI Data Engineer Intern",
    location: "Coimbatore ( On - site )",
    posted: "15 July 2026",
    type: "Intern",
    level: "0 - 6 months",
    description: `We are a deep-technology and advanced systems consultancy specializing in the design, modeling, and deployment of intelligent cyber-physical systems, where electronics and artificial intelligence are engineered together to solve complex, real-world problems. We are a focused team of developers, geospatial specialists, and product thinkers working at the intersection of technology and purpose to build practical, high-impact solutions. 
    
                Role Overview:

                As an AI Data & Integration Engineer Intern, you will collaborate with our AI/ML team to build data ingestion workflows, integrate external systems, automate engineering tasks, and support deployment of AI-powered applications. This role is ideal for someone who enjoys solving practical engineering problems and wants direct exposure to modern AI infrastructure, data pipelines, and application integration. 

                Key Responsibilities:

                • Integrate data sources, REST APIs, and third-party services into existing AI platforms. 
                • Develop and support data ingestion and preprocessing workflows for AI and RAG systems. 
                • Create scripts for data collection, transformation, validation, and quality checks. 
                • Work with vector databases, document stores, and cloud storage services to support retrieval workflows. 
                • Integrate AI models, LLM services, and backend utilities into internal applications. 
                • Automate repetitive engineering workflows to improve development speed and reliability. 
                • Collaborate with AI/ML engineers to test, deploy, and improve AI features. 
                • Monitor, debug, and troubleshoot data pipeline and integration issues. 

                Preferred Skills:
                Required:

                • Basic proficiency in Python. 
                • Understanding of REST APIs and JSON. 
                • Familiarity with Git and version control. 
                • Basic knowledge of databases (SQL or NoSQL). 
                • Ability to debug code, investigate errors, and break down technical problems clearly.  

                Nice to Have:

                • Exposure to web scraping and data collection tools. 
                • Understanding of AI applications such as RAG, vector databases, or LLMs. 
                • Experience with FastAPI, Flask, or backend development. 
                • Familiarity with Docker and Linux environments. 
                • Knowledge of cloud platforms such as AWS, GCP, or Azure. 

                What you'll learn:

                • Building production-oriented AI systems. 
                • Data ingestion and processing pipelines. 
                • AI model integration and deployment workflows. 
                • Retrieval-Augmented Generation (RAG) architectures. 
                • Vector databases and document processing systems. 
                • Engineering practices used in AI product development. 

                Who should apply:

                • Final-year students or recent graduates in Computer Science, AI/ML, IT, or related fields. 
                • Candidates with personal projects, hackathon experience, internships, or practical exposure to APIs, databases, automation, or backend development. 
                • Individuals who can learn quickly, communicate clearly, and contribute in a fast-moving startup environment. 

                  `
    },
    //     "firmware-dev": {
//         title: "Firmware Developer - Medical Devices",
//         location: "Coimbatore",
//         posted: "31 Oct 2025",
//         type: "Full-time",
//         level: "0 - 1 year",
//         description: `The Firmware Developer will create and maintain embedded software responsible for real-time data capture, sensor control, and device communication in medical systems. They will ensure deterministic performance, low-latency response, and fault-tolerant operation across hardware interfaces. Every aspect of the design will prioritize patient safety, data integrity, and adherence to industry standards. 

//                 Responsibilities:

//                     • Develop firmware for microcontrollers (e.g., ARM Cortex, STM32, MSP430) used in medical electronics.
//                     • Implement drivers for sensors, actuators, and communication protocols (UART, SPI, I2C, BLE).
//                     • Optimize code for low power consumption and real-time performance. 
//                     • Conduct unit testing, debugging, and validation of firmware modules.
//                     • Collaborate with electronics and software teams to ensure seamless integration. 
//                     • Ensure firmware meets safety and reliability standards. 
//                     • Maintain version control and documentation for regulatory compliance.


//                 Qualifications:

//                     • Bachelor's or Master's in Embedded Systems, Electronics, or Computer Engineering.
//                     • Proficiency in C/C++ and RTOS-based development.
//                     • Experience with medical device firmware lifecycle and documentation.
                  
//                 Soft Skills:

//                     • Good communication and teamwork skills.
//                     • Attention to Detail: Ensuring accuracy in code and hardware interaction, as even small errors can affect patient safety.
//                     • Problem-Solving Mindset: Ability to debug embedded systems and resolve hardware-software issues efficiently.
//                     • Collaboration & Communication: Working effectively with hardware engineers, biomedical teams, and QA testers to build reliable devices.

//                  `
//     },
//     "junior-electronics-engineer": {
//         title: "Junior Electronics Engineer",
//         location: "Coimbatore",
//         posted: "07 Nov 2025",
//         type: "Full-time",
//         level: "0 - 1 year",
//         description: `We are looking for enthusiastic engineering graduates to join our Design Team. This role is ideal for freshers who are passionate about electronics and eager to work on cutting-edge  technology. You will learn and contribute to the design and development of electronic systems for fetal head position monitoring devices. 

//                 Responsibilities:

//                     • Support senior engineers in designing and testing electronic circuits for medical devices.
//                     • Support PCB layout design and component selection for medical device applications.
//                     • Collaborate with cross-functional teams (mechanical, software, biomedical) to ensure seamless integration.
//                     • Participate in assembling prototypes and conduct testing, troubleshooting, and validation of electronic systems.
//                     • Document work progress and maintain design records. 
//                     • Learn and adhere to medical device safety and compliance standards.


//                 Qualifications:

//                     • Bachelor's degree in Electronics/Electrical Engineering or related discipline (recent graduates welcome).
//                     • Basic understanding of circuit design and electronic components.
//                     • Familiarity with any PCB design tool (Altium, KiCad, or similar) is a plus.
//                     • Strong willingness to learn and adapt to new technologies.
                  
//                 Soft Skills:

//                     • Good communication and teamwork skills.
//                     • Curiosity and eagerness to learn in a fast-paced environment.
//                     • Attention to detail and commitment to quality.
//                  `
//     },

//     "seo-analyst":{
//         title: "SEO Analyst",
//         location: "Coimbatore",
//         posted: "20 Nov 2025",
//         type: "Full-time",
//         level: "0 - 1 year",
//         description:
// `We are looking for a detail-oriented and data-driven SEO Analyst to strengthen our search visibility and drive organic growth. The ideal candidate will analyse website performance, implement SEO best practices, and optimise content to achieve higher rankings. This role requires strong analytical skills, technical SEO knowledge, and the ability to execute effective optimisation strategies.

//             Responsibilities:

//                 • Conduct comprehensive keyword research and competitor analysis to identify ranking opportunities.
//                 • Perform on-page SEO optimisation, including meta tags, header structures, internal linking, and content improvements.
//                 • Monitor website performance using tools like Google Analytics, Search Console, and SEO auditing tools.
//                 • Optimise website structure and technical elements (crawlability, indexability, schema markup, page speed).
//                 • Track keyword rankings and prepare weekly/monthly SEO performance reports.
//                 • Collaborate with content creators to develop SEO-friendly blogs, landing pages, and website updates.
//                 • Identify backlink opportunities and assist in building high-quality link-building strategies.
          
//             Qualifications:

//                 • Bachelor's degree in Marketing, Computer Science, Business, or a related field.
//                 • 0 - 1 years of experience in SEO, digital marketing, or website optimisation.
//                 • Strong understanding of on-page, off-page, and technical SEO fundamentals.
//                 • Experience with SEO tools such as Google Analytics, Search Console, SEMrush, Ahrefs, Moz, or Screaming Frog.
//                 • Knowledge of website performance metrics, keyword research tools, and ranking analysis.
//                 • Basic understanding of HTML, CSS, and website CMS platforms (preferred).
//                 • Ability to analyse data and provide actionable insights to improve search performance.

//             Soft Skills:

//                 • Excellent analytical and reporting skills with a strong attention to detail.
//                 • Good communication and ability to explain technical concepts in simple terms.
//                 • Organised, proactive, and able to manage multiple optimisation tasks simultaneously.
//                 • Problem-solving mindset with the ability to identify issues and propose effective SEO solutions.
//                 • Curiosity to stay updated with industry changes, Google algorithm updates, and SEO trends.
// `
//     },
    // "fsd-intern": {
    //     title: "Full-Stack Developer",
    //     location: "Coimbatore",
    //     posted: "31 Oct 2025",
    //     type: "Full-time",
    //     level: "0 - 1 year",
    //     description: `We are looking for a passionate and motivated Full Stack Developer (MERN Stack) to join our team. This job will provide hands-on experience in building scalable web applications using the latest technologies. You will work closely with our development team on real-world projects and gain exposure to the full software development lifecycle. 

    //             Responsibilities:

    //                 • Assist in designing, developing, and maintaining web applications using MERN stack (MongoDB, Express.js, React.js, Node.js).
    //                 • Collaborate with senior developers to write clean, efficient, and reusable code. 
    //                 • Work on both frontend (React.js) and backend (Node.js, Express.js) tasks. 
    //                 • Help in integrating RESTful APIs and third-party services.
    //                 • Debug, test, and document code to ensure quality and reliability. 
    //                 • Participate in team meetings, brainstorming sessions, and code reviews.
                    

    //             Qualifications:

    //                 • Recent Graduate student (B.E, B.Sc, MCA, or equivalent) with a keen interest in full stack development. 
    //                 • Basic knowledge of JavaScript, HTML, CSS and understanding of React.js & Node.js. 
    //                 • Familiarity with databases (MongoDB / PostgreSQL preferred). 
    //                 • Understanding of Git/GitHub for version control.
    //                 • Good problem-solving and communication skills.
    //                 • Ability to learn quickly and work in a collaborative team environment.
                    

    //             Soft Skills: 

    //                 • Keeps up with evolving technologies, frameworks, and tools in both frontend and backend development.  
    //                 • Communicates clearly with designers, backend/frontend teams and clients to understand requirements and deliver solutions. 
    //                 • Manages multiple tasks like development, testing, API integration, deployment and also taking responsibility for deliverables.
    //                 • Able to debug both frontend and backend issues, optimize performance, and find logical solutions across the tech stack.
    //                 `
    // },
 
};

const JobDetail = () => {
    const { jobId } = useParams();
    const navigate = useNavigate();
    const job = jobData[jobId];

    useEffect(() => {
        AOS.init({
            duration: 1500,
            once: true,
        });
    }, []);

    if (!job) return <div>Job not found</div>;
    
    return (
        <>
            <SEOHead 
                title={`${job.title} - ${job.location}`}
                description={`Join AK Consultants as ${job.title} in ${job.location}. ${job.level} experience required. ${job.type} position. Apply now for exciting career opportunities.`}
                keywords={`${job.title}, ${job.location}, ${job.type}, careers, jobs, AK Consultants`}
            />
            <div className="job-detail">
                <div className="hero-banner" data-aos="fade-up">
                    <h2>{job.location}</h2>
                    <h1>{job.title}</h1>
                    <button className="apply-btn1" onClick={() => navigate(`/careers/${jobId}/apply`)}>
                        Apply now →
                    </button>
                </div>
                <div className="job-content" data-aos="fade-up">
                    <div className="job-description">
                        <h3>Job Description</h3>
                        <p>
                            {job.description.split('\n').map((line, index) => {
                                const boldHeadings = [
                                    "Key Impact & Responsibilities:",
                                    "What You'll Learn:",
                                    "Qualifications:",
                                    "Preferred Skills:",
                                    "Key Responsibilities:",
                                    "Responsibilities:",
                                    "Requirements:",
                                    "Preferred(Good to Have):",
                                    "Perks & Benefits:",
                                    "What We Offer:",
                                    "Soft Skills",
                                    "What You'll Do",
                                    "What We're Looking For",
                                    "Why Join Us?",
                                    "Required Skills",
                                    "Eligibility",
                                    "What You'll Gain",
                                    "Role Overview",
                                    "Required",
                                    "Nice to Have",
                                    "What you'll learn",
                                    "Who should apply",
                                    "Content Creation & Marketing", 
                                    "Social Media Management", 
                                    "SEO & Website Optimisation", 
                                    "Digital Campaigns",
                                    "Analytics & Reporting", 
                                    "Market Research", 
                                    "Skills & Qualifications", 
                                    "Preferred Skills",
                                    "Market Research & Opportunity Identification", 
                                    "Lead Generation & Client Engagement", 
                                    "Proposal & Bid Support", 
                                    "Partnership Development",
                                    "Sales Support", 
                                    "Strategic Initiatives",
                                    "( With potential conversion to a full-time role based on performance )"
                                ];

                                const isHeading = boldHeadings.some(h => line.trim().startsWith(h));

                                return (
                                    <React.Fragment key={index}>
                                        {isHeading ? <strong>{line}</strong> : line}
                                        <br />
                                    </React.Fragment>
                                );
                            })}
                        </p>

                        <button className="apply-btn" onClick={() => navigate(`/careers/${jobId}/apply`)}>
                            Apply now →
                        </button>
                    </div>
                    <div className="job-meta2">
                        <p style={{ color: "black" }}><strong>Posted on:</strong> {job.posted}</p>
                        <p style={{ color: "black" }}><strong>Experience:</strong> {job.level}</p>
                        <p style={{ color: "black" }}><strong>Job type:</strong> {job.type}</p>
                        <p style={{ color: "black" }}><strong>Location:</strong> {job.location}</p>
                    </div>
                </div>
            </div>
            <div style={{ marginBottom: '80px' }}></div>
            <div style={{ marginTop: '200px' }}>
                <Footer />
            </div>
        </>
    );
};

export default JobDetail;
